function createElem(elementType, classes, attributes) {
    var elem = document.createElement(elementType);
    if (typeof classes != undefined && classes != null) {
        for (var i = 0; i < classes.length; i++) {
            elem.classList.add(classes[i]);
        }
    }
    if (typeof attributes != undefined && attributes != null) {
        Object.keys(attributes).map(function (objectKey, index) {
            var value = attributes[objectKey];
            elem.setAttribute(objectKey, value);
        });
    }
    return elem;
}

function deleteButton(label, onClick) {
    var button = createElem('button', ['close']);
    button.type = 'button';
    button.name = 'button';
    button.innerText = label;
    button.onclick = onClick;
    return button;
}

function settingsList(data) {
    var result = [];
    if (typeof data != undefined && data != null && data.length > 0) {
        for (var i = 0; i < data.length; i++) {
            result.push(data[i]);
        }
    }
    return result;
}

function createAndAssignOptions(settingsList, select) {
    if (typeof settingsList != undefined && settingsList != null && settingsList.length > 0) {
        for (var i = 0; i < settingsList.length; i++) {
            var option = createElem('option');
            $(option).attr('label', settingsList[i]);
            $(option).attr('value', settingsList[i]);
            select.add(option);
        }
    }
}

function createInput(setting) {
    var input = createElem('input', ['form-control']);
    input.type = 'text';
    input.name = 'custom_form_field[settings][' + setting + ']';
    return input;
}

function createSwitch() {
    var checkbox = createElem('input', ['switchBox']);
    checkbox.type = 'radio';
    checkbox.checked = false;
    checkbox.name = 'custom_form_field[settings][required]';
    $(checkbox).on({
        'switchChange.bootstrapSwitch': function () {
            if ($(checkbox).is(':checked')) {
                $(checkbox).attr("value", "true");
            } else {
                $(checkbox).attr("value", "false");
            }
        }
    });
    return checkbox;
}

function createHiddenField() {
    var hidden = createElem('input');
    hidden.type = 'hidden';
    hidden.name = 'custom_form_field[settings][required]';
    hidden.value = 'false';
    return hidden;
}

function createField(type) {
    if (type == 'required') {
        return createSwitch();
    } else if (type == 'hidden') {
        return createHiddenField();
    } else {
        return createInput(type);
    }
}

function changeDivInner(div, replace) {
    $(div).empty();
    var label = createElem('label');
    label.innerText = 'Value';
    var settingsValueHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#settings').data('value-help')});
    $(div).append(label);
    $(div).append(' ');
    $(div).append(settingsValueHelpIcon);
    if (replace.type == 'radio') {
        $(div).append(createField('hidden'));
    }
    $(div).append(replace);
    if (replace.type == 'radio') {
        $(replace).bootstrapSwitch({onColor: 'success', offColor: 'warning'});
    }
}

function deleteValidation(self, id) {
    var url = document.location.protocol + '//' + document.location.host + $('#validations').data('delete_url').slice(0, -1) + id;
    $.ajax({
        url: url,
        method: 'DELETE',
        dataType: 'json',
        beforeSend: function () {
            self.disabled = true;
        },
        success: function () {
            deleteOption(self, id);
        },
        error: function () {
            alert('There is something wrong with custom form field validation deletion. Please, try again later.');
        }
    });
}

function optionRow(id) {
    var wrapper = createElem('div', ['form-group']);
    $(wrapper).append(deleteButton(' ×', function () {
        deleteOption(this, id)
    }));
    return wrapper;
}

function deleteOption(self, id, remote) {
    remote = typeof remote !== 'undefined' ? remote : false;
    if (remote) {
        deleteValidation(self, id);
    } else {
        self.parentNode.remove();
        if (typeof id != undefined && id != null) {
            var idx = '#select_opt option[id=' + id + ']';
            $(idx).remove();
        }
        if ($('.hidden_fields').length <= 0) {
            $('#select_opt').remove();
            $('#example_label').remove();
            $('#options_container').empty();
            deleteElement('h3_options');
        }
        if ($('.settings_row').length <= 0) {
            deleteElement('h3_settings');
        }
        if ($('.validations_row').length <= 0) {
            deleteElement('h3_validations');
        }
    }
}

function bootstrapSwitchChange(bootstrapSwitch, type, multi) {
    multi = typeof multi !== 'undefined' ? multi : false;
    $(bootstrapSwitch).on({
        'switchChange.bootstrapSwitch': function () {
            var option = '#select_opt option[id=' + $(this).data('id') + ']';
            var name = '[name="custom_form_field[options][' + $(this).data('id') + '][' + type + ']"]';
            if ($(this).is(':checked')) {
                if (type == 'selected') {
                    $('.select_options').removeAttr("selected");
                    $(option).attr("selected", "selected");
                    $('#select_opt').val($(option).val());
                }
                multi ? $('.hidden_fields').val('false') : false;
                $(name).val(true);
            } else {
                if (type == 'selected') {
                    $(option).removeAttr("selected");
                }
                $(name).val(false);
            }
        }
    });

}

function deleteElement(id) {
    $('#' + id).remove();
}

function addElement(id, element) {
    $('#' + id).prepend(element);
}

function createH3Label(label, id) {
    var h3 = createElem('h3');
    $(h3).css('margin-top', '15px');
    h3.innerText = label;
    h3.id = id;
    return h3;
}

export {
  createElem,
  settingsList,
  createAndAssignOptions,
  createField, changeDivInner,
  optionRow,
  bootstrapSwitchChange,
  addElement,
  createH3Label,
  deleteOption
}
